import React from "react";
import PaymentAdviceTable from "../components/applications/table/paymentAdviceTable";
import { Link, useNavigate } from "react-router-dom";
import { Home, ChevronRight, ArrowLeft } from "lucide-react";

function PaymentAdvicePage() {
  const navigate = useNavigate();

  return (
    <>
      <div className="w-full max-w-[95%] mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Link
              to="/dashboard"
              className="flex items-center hover:text-green-600 transition-colors"
            >
              <Home size={16} />
            </Link>
            <ChevronRight size={16} className="text-gray-300" />
            <span className="font-semibold text-gray-900">Payment Advice</span>
          </div>

          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-900 transition-colors"
          >
            <ArrowLeft size={16} /> Back
          </button>
        </div>
      </div>

      <div className="flex flex-col w-full max-w-[95%] mx-auto px-4 sm:px-6 lg:px-8 mt-12 mb-4">
        <h1 className="text-lg font-semibold text-gray-700">Payment Advice</h1>
        <p className="text-sm text-slate-500 mt-1">
          Manage and generate stipend payments for cleared interns.
        </p>
      </div>

      <main className="relative">
        <div className="flex space-x-4 px-6 m-auto">
          <PaymentAdviceTable />
        </div>
        <div className="px-2 sm:px-2 lg:px-2 py-2 w-full max-w-9xl mx-auto"></div>
      </main>
    </>
  );
}

export default PaymentAdvicePage;
